import React, {useEffect, useState} from 'react'
import {CircularProgress, Container} from '@mui/material'
import Api from '../../services/api.service'
import {withRouter} from 'react-router-dom'
import Helmet from 'react-helmet'

const Page = props => {
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState({})
  const {slug} = props.match.params

  useEffect(() => {
    getPage()
  }, [slug])

  const getPage = () => {
    setLoading(true)

    Api.get(`/api/web/pages`, {
      params: {
        slug: slug,
      },
    }).then(response => {
      setPage(response.data.results[0])
      setLoading(false)
    })
  }

  return (
    <div className="main">
      <Helmet>
        <title>{page.title}</title>
      </Helmet>

      <div className="main__content">
        <div className="wrapper">
          <Container>
            {loading && <CircularProgress />}
            <div dangerouslySetInnerHTML={{__html: page.body}} />
          </Container>
        </div>
      </div>
    </div>
  )
}

export default withRouter(Page)
